import DailyTargetReachedModal from "./DailyTargetReachedModal";
import { useLiveWireStore } from "@/stores/livewire";
import { useShallow } from "zustand/react/shallow";
import Confetti from "@/components/fun/Confetti";

const achievements = {
  dailyTarget: DailyTargetReachedModal,
};

const AchievementModals = ({ duration = 10000 }) => {
  const [activeAchievement, setActiveAchievement] = useLiveWireStore(
    useShallow((state) => [state.activeAchievement, state.setActiveAchievement])
  );

  const handleModalClose = () => {
    setActiveAchievement(null);
  };

  const AchievementModal = achievements[activeAchievement];

  return (
    <div className="achievement-modals">
      <Confetti enabled={!!activeAchievement} />
      {AchievementModal && (
        <>
          <AchievementModal onHide={handleModalClose} duration={duration} />
        </>
      )}
    </div>
  );
};

export default AchievementModals;
